<template>
  <div class="editor-documents">
    <collapse accordion>
      <panel
        v-for="type in types"
        :key="type.id"
        :name="type.name"
      >
        {{ type.name }}
        <span class="ms-help">({{ getFilesCount(type.id) }})</span>
        <div slot="content">
          <Upload
            multiple
            type="drag"
            :action="uploadURL"
            :headers="uploadHeaders"
            :on-success="response => onUploadSuccess(type.id, response)"
            :on-remove="onRemoveFile"
          >
            <div style="padding: 8px 0">
              <icon
                type="ios-cloud-upload"
                size="32"
                style="color: #4484ce"
              />
              <p style="font-size: 12px">
                Перетащите необходимые файлы для загрузки
              </p>
            </div>
          </Upload>
        </div>
      </panel>
    </collapse>
  </div>
</template>

<script>
import { mainUrl } from '@/config/urls'

export default {
  props: ['contract'],
  data () {
    return {
      loading: false,
      types: [],
      uploadURL: `${mainUrl}/api/upload_resource`,
      uploadHeaders: { token: this.$store.state.auth.token }
    }
  },
  methods: {
    getFilesCount (typeId) {
      return this.contract.object_resources.filter(f => f.file_type_id === typeId).length
    },
    onUploadSuccess (file_type_id, response) {
      response.forEach(resource_id => {
        this.contract.object_resources.push({
          file_type_id,
          resource_id
        })
      })
    },
    onRemoveFile (file) {
      const [id] = file.response
      this.contract.object_resources = this.contract.object_resources.filter(
        file => file.resource_id !== id
      )
    }
  },
  async created () {
    try {
      this.loading = true
      const fileTypes = await this.$store.dispatch('GET_REQUEST', {
        url: `objectInfo/file_types`
      })
      const sortFn = (a, b) => a.index - b.index

      this.types = fileTypes.filter(
        t => t.object_name === 'contracts' && t.category === 'Основной договор'
      ).sort(sortFn)
      this.loading = false
    } catch (error) {
      console.log(error)
      this.loading = false
    }
  }
}
</script>

<style>
</style>
